import {ADD_FLAGS } from '../types'
  
  const INITIAL_STATE = {
    addFlag:[],
    
  }
  
  const flagReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case ADD_FLAGS:
          return {
            ...state,
            addFlag: payload.data,
          }
     
      default:
        return state
    }
  }
  
  export default flagReducer
  